$(document).ready(function () {
  $(
    ".button:not(.cart-items .button, .collection .button, .active-facets .button, .cart__ctas button)"
  ).append(
    '<span class="cstm_btn_shape"><svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 9.31836L8 6.31836L5 3.31836" stroke="#262626" stroke-linecap="round" stroke-linejoin="round"/></svg></span>'
  );

 $(
    ".shopify-payment-button__button"
  ).append(
    '<span class="cstm_btn_shape"><svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 9.31836L8 6.31836L5 3.31836" stroke="#262626" stroke-linecap="round" stroke-linejoin="round"/></svg></span>'
  );

  

  // Featured Slider
  var swiper = new Swiper(".featured_slider", {
    slidesPerView: 4,
    spaceBetween: 30,
    navigation: {
      nextEl: ".featured_slider_main .swiper-button-next",
      prevEl: ".featured_slider_main .swiper-button-prev",
    },
    breakpoints: {
      300: {
        slidesPerView: 1,
        spaceBetween: 15,
      },
      500: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
      850: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      1200: {
        slidesPerView: 4,
      },
    },
  });

  // Reviews Slider
  var swiper = new Swiper(".review_slider", {
    slidesPerView: 3,
    spaceBetween: 20,
    pagination: {
      el: ".swiper-pagination",
      type: "progressbar",
    },
    breakpoints: {
      300: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      600: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      900: {
        slidesPerView: 3,
      },
    },
  });

  // TImeline Slider
  var swiper = new Swiper(".timeline_slider", {
    slidesPerView: 3,
    spaceBetween: 50,
    navigation: {
      nextEl: ".timeline_wr .swiper-button-next",
      prevEl: ".timeline_wr .swiper-button-prev",
    },
    breakpoints: {
      300: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      750: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      900: {
        slidesPerView: 3,
      },
    },
  });

  // month wise array
  // var all_months = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];
  // var li_months = [];
  // $('.archive_single_2021 ul li').each(function(){
  //  var data_month = $(this).attr('data-month');
  //   li_months.push(data_month);
  // });

  // li_months.sort(function(a,b){
  //   return all_months.indexOf(a) - all_months.indexOf(b);
  // });
  // console.log(li_months);

  $("#archives .archive_single").each(function () {
    var data_yr = $(this).attr("data-year");
    var months = [
      "december",
      "november",
      "october",
      "september",
      "august",
      "july",
      "june",
      "may",
      "april",
      "march",
      "february",
      "january",
    ];
    var month_anchor = `.archive_single_${data_yr} #sortedMonths a`;

    var unsortedList = $(month_anchor);
    var sortedList = unsortedList.sort(function (a, b) {
      return months.indexOf($(a).text()) - months.indexOf($(b).text());
    });
    var month_div = `.archive_single_${data_yr} #sortedMonths`;

    $(month_div).append(sortedList);
  });

  $(document).on("keyup", "#search-criteria", function () {
    var txt = $("#search-criteria").val();
    console.log(txt);
    $("#product-grid li").each(function () {
      if ($(this).text().toUpperCase().indexOf(txt.toUpperCase()) != -1) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });
  });

  $('.itg_variant  label#image_label').click(function(){
   var cstm_name =  $(this).attr('value');
    $('.form__label .var_name').text(cstm_name);
  });

  
});
